import { render, staticRenderFns } from "./UmsatzerloeseVergleich.vue?vue&type=template&id=1889ef14&"
import script from "./UmsatzerloeseVergleich.vue?vue&type=script&lang=ts&"
export * from "./UmsatzerloeseVergleich.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports